<template>
  <div class="edit-product">
    <div class="breadcrumb" style="background: #fff">创建产品</div>
    <div class="third-title" @click="qwe"><span>基础信息</span></div>
    <div class="order-detail-basic" style="padding-top: 0">
      <el-form hide-required-asterisk :model="basicInfo" :rules="rules" label-width="170px" ref="formRef">
        <el-form-item label="产品分类:" prop="ownCategoryId" class="address-ipt">
          <el-select v-model="category.ownCategoryId" value-key="id" @change="basicInfo.startupsSpu = 0, getTypeSecond()" placeholder="请选择" clearable>
            <el-option v-for="item in typeFirst" :key="item.id" :label="item.categoryName" :value="item"></el-option>
          </el-select>
          <el-select v-model="category.topCategoryId" value-key="id" v-show="typeSecond.length !== 0" @change="getTypeThird" placeholder="请选择" clearable>
            <el-option v-for="item in typeSecond" :key="item.id" :label="item.categoryName" :value="item"></el-option>
          </el-select>
          <el-select v-model="category.subCategoryId" value-key="id" v-show="typeThird.length !== 0" @change="getTypeFourth" placeholder="请选择" clearable>
            <el-option v-for="item in typeThird" :key="item.id" :label="item.categoryName" :value="item"></el-option>
          </el-select>
          <el-select v-model="category.categoryId" value-key="id" v-show="typeFourth.length !== 0" placeholder="请选择" clearable>
            <el-option v-for="item in typeFourth" :key="item.id" :label="item.categoryName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称:" prop="spuName">
          <el-input v-model="basicInfo.spuName"></el-input>
        </el-form-item>
        <el-form-item label="产品描述:" prop="spuDesc">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="basicInfo.spuDesc"></el-input>
        </el-form-item>
        <el-form-item label="产品类型:" prop="spuType" v-if="$route.query.id == 0">
          <el-select v-model="basicInfo.spuType" placeholder="请选择" clearable>
            <el-option v-for="item in productypeList" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品性质:" prop="spuProperty">
          <el-select v-model="basicInfo.spuProperty" placeholder="请选择" clearable>
            <el-option v-for="item in natureList" :key="item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品标签:" v-if="queryId === '0'">
          <el-button type="primary" round @click="choiceTagDialog = true">选择标签</el-button>
        </el-form-item>
        <el-form-item label="已选标签:" v-if="queryId === '0'">
          <div>
            <el-table :data="tagList" border style="width: 100%" :row-class-name="rowClassName">
              <el-table-column prop="label" label="标签" width="150px"></el-table-column>
              <el-table-column label="操作" width="150px">
                <template v-slot="scope">
                  <span class="color-blue" @click="tagList.splice(scope.$index, 1)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="是否参与折扣包:">
          <el-switch v-model="basicInfo.discountBundle" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <div v-for="(v, k) in spuComposeAreaList" :key="k">
          <el-form-item :label="$config.pageType[k] + '合成区:'" v-if="+$route.query.id === 0 && basicInfo.spuProperty !== 'NORMAL'" :prop="k">
            <el-select v-model="spuComposeAreaList[k].composeArea" value-key="id" filterable placeholder="请选择" clearable>
              <el-option v-for="item in areaList" :key="item.id" :label="item.areaName" :value="item"></el-option>
            </el-select>
            <el-button type="primary" v-if="queryId === '0' && spuComposeAreaList[k].composeArea.id" round @click="(areaLine = spuComposeAreaList[k].composeArea), (dialogVisible = true)"> 查看合成区属性
            </el-button>
            <el-form-item label="机器码:" label-width="60" v-if="spuComposeAreaList[k].composeArea.leftComposeCode === 'MACHINE_CODE'">
              <el-select v-model="spuComposeAreaList[k].machineCodeId" @change="$refs.formRef.validateField(k)" filterable placeholder="请选择" clearable>
                <el-option v-for="item in machineCodeList" :key="item.machineCodeName + item.id" :label="item.machineCodeName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </div>
        <el-form-item label="支持分辨率:" v-if="basicInfo.spuProperty !== 'NORMAL'" prop="spuDpi"> 300,254 <!-- <el-radio-group v-model="basicInfo.spuDpi" style="margin-top:8px;">
            <el-radio :label="300">300</el-radio>
            <el-radio :label="254">254</el-radio>
          </el-radio-group> -->
        </el-form-item>
        <el-form-item label="选择所需属性:" v-if="queryId === '0'">
          <el-button type="primary" round @click="choiceAttrDialog = true">选择属性</el-button>
        </el-form-item>
        <el-form-item label="" v-if="queryId === '0'" prop="attrList">
          <div>
            <el-table :data="attrList" border style="width: 100%" :row-class-name="rowClassName">
              <el-table-column prop="propKey" label="属性" width="150px"></el-table-column>
              <el-table-column label="操作" width="150px">
                <template v-slot="scope">
                  <span class="color-blue" @click="attrList.splice(scope.$index, 1)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="特殊排版:">
          <el-switch v-model="basicInfo.specialLayout" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
          <span style="color:#F56C6C;width: 100%;margin-left: 10px;">此设置为：首页左半页留白，尾页右半页留白的相册产品</span>
        </el-form-item>
        <!-- 婚纱类型的产品显示 -->
        <el-form-item label="是否初创产品:" v-if="category.ownCategoryId.id == 10">
          <el-switch v-model="basicInfo.startupsSpu" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="在线设计:" v-if="this.queryId != 1">
          <el-checkbox-group v-model="onlineDesign">
            <el-checkbox :label="1" :disabled="onlineDesign[0] == 4 || onlineDesign[1] == 4">选模板(不含DIY)</el-checkbox>
            <el-checkbox :label="2">智能设计</el-checkbox>
            <el-checkbox :label="4" :disabled="onlineDesign[0] == 1 || onlineDesign[1] == 1">选模板(含DIY)</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="queryId === '0' && basicInfo.spuProperty !== 'NORMAL'" label="白页:">
          <el-switch v-model="allowWhitePage" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item v-if="queryId === '0' && basicInfo.spuProperty !== 'NORMAL'" v-show="allowWhitePage" label="" prop="allowWhitePage">
          <div>
            <el-button type="primary" @click="(whiteQueryInfo.pageNum = 1), getWhitePageList(), (whitePageDialog = true)" style="margin: 0 0 10px 0" round> 选择白页 </el-button>
            <el-table :data="selectWhitePage" border style="width: 100%">
              <el-table-column prop="whitePageName" label="白页名称" width="200px"></el-table-column>
              <el-table-column prop="date" label="白页出现位置" width="200px">
                <template slot-scope="scope">
                  <p> 封面：{{ scope.row.whitePageCoverPosition === 'FIRST_PAGE' ? '首页' : scope.row.whitePageCoverPosition === 'LAST_PAGE' ? '尾页' : scope.row.whitePageCoverPosition === 'FIRST_LAST_PAGE'
                    ? '首页,尾页' : scope.row.whitePageCoverPosition === 'NO_PAGE' ? '无' : scope.row.whitePageCoverPosition === 'AFTER_ADD1_PAGE' ? '每P后+1P白' : '未定义' }} </p>
                  <p> 内页：{{ scope.row.whitePageTextPosition === 'FIRST_PAGE' ? '首页' : scope.row.whitePageTextPosition === 'LAST_PAGE' ? '尾页' : scope.row.whitePageTextPosition === 'FIRST_LAST_PAGE' ?
                    '首页,尾页' : scope.row.whitePageTextPosition === 'NO_PAGE' ? '无' : scope.row.whitePageTextPosition === 'AFTER_ADD1_PAGE' ? '每P后+1P白' : '未定义' }} </p>
                  <p> 单页：{{ scope.row.whitePageSinglePosition === 'FIRST_PAGE' ? '首页' : scope.row.whitePageSinglePosition === 'LAST_PAGE' ? '尾页' : scope.row.whitePageSinglePosition ===
                    'FIRST_LAST_PAGE' ? '首页,尾页' : scope.row.whitePageSinglePosition === 'NO_PAGE' ? '无' : scope.row.whitePageSinglePosition === 'AFTER_ADD1_PAGE' ? '每P后+1P白' : '未定义' }} </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="queryId === '0' && basicInfo.spuProperty !== 'NORMAL'" label="内页页码:">
          <el-switch v-model="allowPage" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item v-if="queryId === '0' && basicInfo.spuProperty !== 'NORMAL'" v-show="allowPage" label="" prop="allowPage">
          <div>
            <el-button type="primary" @click="(paginationQueryInfo.pageNum = 1), getPaginationList(), (PaginationDialog = true)" style="margin: 0 0 10px 0" round> 选择页码 </el-button>
            <el-table :data="selectPagnation" border style="width: 100%">
              <el-table-column prop="pageName" label="页码名称" width="200px"></el-table-column>
              <el-table-column prop="startPage" label="页码起始页" width="200px"></el-table-column>
              <el-table-column prop="pageNumber" label="每P页码数" width="200px"></el-table-column>
              <el-table-column prop="date" label="参数" width="220px">
                <template slot-scope="scope">
                  <p v-for="(item, index) in scope.row.pageNumberDetailList" :key="item.id"> 页码{{ index + 1 }}：{{ (item.portrait === 'top' ? '距上' : '距下') + ':' + item.portraitParam + 'mm,' +
                    (item.transverse === 'left' ? '距左' : '距右') + ':' + item.transverseParam + 'mm' }} </p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="PDF产品:" v-if="queryId === '0'">
          <el-switch v-model="basicInfo.isPdf" active-color="#1473E6" inactive-color="#8c8c8c" @change="isPdfChange"></el-switch>
        </el-form-item>
        <el-form-item label="上传前PDF文件:" v-if="basicInfo.isPdf">
          <el-upload action="#" :http-request="(e) => uploadFilePdf(e, 'front')" :show-file-list="false">
            <el-button type="primary" round v-preventReClick>上传文件</el-button>
            <div slot="tip" class="el-upload__tip">{{ frontFile.pdfName }} <i class="el-icon-circle-close" style="cursor:pointer;color:red !important;" v-if="frontFile.pdfName"
                @click="deletePdf('front')"></i></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传后PDF文件:" v-if="basicInfo.isPdf">
          <el-upload action="#" :http-request="(e) => uploadFilePdf(e, 'after')" :show-file-list="false">
            <el-button type="primary" round v-preventReClick>上传文件</el-button>
            <div slot="tip" class="el-upload__tip">{{ afterFile.pdfName }} <i class="el-icon-circle-close" style="cursor:pointer;color:red !important;" @click="deletePdf('after')"
                v-if="afterFile.pdfName"></i></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="前后PDF上传总P数:" prop="pdfFixedNums" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfFixedNums" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfFixedNums" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="是否修改pdf尺寸:" v-if="basicInfo.isPdf">
          <el-switch v-model="basicInfo.isModifyPdfSize" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="PDF插入页序:" prop="pdfPosition" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfPosition" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfPosition" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="模板页总页数:" prop="pdfTemplateNums" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfTemplateNums" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfTemplateNums" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="PDF不进入到合成页序:" prop="pdfNoComposePage" v-if="basicInfo.isPdf">
          <!-- <el-input v-model="basicInfo.pdfNoComposePage" type="number"></el-input> -->
          <el-input-number v-model="basicInfo.pdfNoComposePage" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="是否允许上传pdf:">
          <el-switch v-model="basicInfo.uploadPdf" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item v-if="queryId === '0' && basicInfo.spuProperty !== 'NORMAL'" label="能否从尺寸匹配到此产品:">
          <el-switch v-model="basicInfo.allowMatchSize" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="是否隐藏此产品:">
          <el-switch v-model="basicInfo.isHidden" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="SAAS端能否读取此产品:">
          <el-switch v-model="basicInfo.isPushSaas" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="DIY收选片:" v-if="$route.query.id == 0 && basicInfo.spuProperty !== 'NORMAL'">
          <el-switch v-model="basicInfo.isDiy" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="isDiyDisable"></el-switch>
        </el-form-item>
        <el-form-item label="是否推送到C端:" v-if="$route.query.id == 0">
          <el-switch v-model="basicInfo.isPushTerminal" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <!-- <el-form-item label="是否是单Sku组:" v-show="basicInfo.isSingleSkuGroup">
          <el-switch v-model="basicInfo.isSingleSkuGroup" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item> -->
        <el-form-item label="是否开码:" v-show="basicInfo.isPushTerminal">
          <el-switch v-model="basicInfo.isHavePromoCode" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="纪念日台历:" v-show="basicInfo.isPushTerminal">
          <el-switch v-model="basicInfo.isCommemorationDay" active-color="#1473E6" inactive-color="#8c8c8c" @change="onComDay"></el-switch>
        </el-form-item>
        <el-form-item label="是否云端设计:" v-show="basicInfo.isPushTerminal">
          <el-switch v-model="basicInfo.isCloudDesign" active-color="#1473E6" inactive-color="#8c8c8c" :disabled="basicInfo.isCommemorationDay ? true : false"></el-switch>
        </el-form-item>
        <el-form-item label="产品价格是否唯一:" v-if="queryId === '0'">
          <el-switch v-model="basicInfo.singlePrice" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item>
        <el-form-item label="上传补页:" prop="spuPdfAddPageVO">
          <input @change="fileChange($event, 'spuPdfAddPageVO')" type="file" id="upload_file_pdf" multiple style="display: none" />
          <draggable v-model="basicInfo.spuPdfAddPageVO" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index === 0 ? 'filter' : ''" v-for="(item, index) of basicInfo.spuPdfAddPageVO" :key="index">
              <div class="upload_img">
                <el-image :src="item.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <!-- <p class="upload_warp_img_div_del color-blue" @click="fileMain(index, 'spuPdfAddPageVO')" v-show="index !== 0">设为主图</p> -->
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'spuPdfAddPageVO')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.spuPdfAddPageVO.length !== 3">
              <div class="upload_warp_left" @click="fileClick('upload_file_pdf')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.spuPdfAddPageVO.length }}/3</div>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <!-- <el-form-item label="是否推送到C端首页:" v-show="basicInfo.isPushTerminal">
          <el-switch v-model="basicInfo.isPushTerminalIndex" active-color="#1473E6" inactive-color="#8c8c8c"></el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="封面合成位置:" v-if="queryId === '0'">
          <el-select v-model="basicInfo.coverPosition" value-key="id" placeholder="请选择" clearable>
            <el-option label="首页" value="FIRST_PAGE"></el-option>
            <el-option label="尾页" value="LAST_PAGE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面合成坐标:" v-if="queryId === '0'"> 左：<el-input type="number" style="width:200px" v-model="basicInfo.leftParam" placeholder=""><template slot="append">mm</template>
          </el-input> 上：<el-input style="width:200px" type="number" v-model="basicInfo.topParam" placeholder=""><template slot="append">mm</template></el-input>
        </el-form-item> -->
        <el-form-item class="noleft-third-title">
          <div class="third-title" @click="asd"><span>产品详情</span></div>
        </el-form-item>
        <el-form-item label="产品图片:" prop="primaryImages">
          <input @change="fileChange($event, 'primaryImages')" type="file" id="upload_file" multiple style="display: none" />
          <draggable v-model="basicInfo.primaryImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index === 0 ? 'filter' : ''" v-for="(item, index) of basicInfo.primaryImages" :key="index">
              <div class="upload_img">
                <el-image :src="item.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileMain(index, 'primaryImages')" v-show="index !== 0">设为主图</p>
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'primaryImages')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.primaryImages.length !== getMaxImg">
              <div class="upload_warp_left" @click="fileClick('upload_file')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.primaryImages.length }}/{{ getMaxImg }}</div>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item label="产品3:4图片:" prop="primaryAppImages">
          <input @change="fileChange($event, 'primaryAppImages')" type="file" id="upload_file_app" multiple style="display: none" />
          <draggable v-model="basicInfo.primaryAppImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index === 0 ? 'filter' : ''" v-for="(item, index) of basicInfo.primaryAppImages" :key="index">
              <div class="upload_img">
                <!-- <img :src="item.url"> -->
                <el-image :src="item.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileMain(index, 'primaryAppImages')" v-show="index !== 0">设为主图</p>
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'primaryAppImages')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.primaryAppImages.length !== 5">
              <div class="upload_warp_left" @click="fileClick('upload_file_app')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.primaryAppImages.length }}/5</div>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;">按住ctrl/shift可同时批量选择多张图片上传，最多可以上传5张图片</p>
        </el-form-item>
        <!-- <el-form-item label="C端产品图片:" v-show="basicInfo.isPushTerminal">
          <input @change="fileChange($event,'spuTerminalPrimaryImages')" type="file" id="upload_C_img" multiple style="display: none">
          <draggable v-model="basicInfo.spuTerminalPrimaryImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300"
            class="upload_warp_img">
            <div class="upload_warp_img_div" :class="index===0?'filter':''" v-for="(item,index) of basicInfo.spuTerminalPrimaryImages" :key="index">
              <div class="upload_img"> -->
        <!-- <img :src="item.url"> -->
        <!-- <el-image :src="item.url" fit='contain' style="width:100%;height:100%" :preview-src-list="[item.url]"></el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileMain(index,'spuTerminalPrimaryImages')" v-show="index!==0">设为主图</p>
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index,'spuTerminalPrimaryImages')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left" v-show="basicInfo.spuTerminalPrimaryImages.length !==5">
              <div class="upload_warp_left" @click="fileClick('upload_C_img')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
                <div class="">{{ basicInfo.spuTerminalPrimaryImages.length }}/5</div>
              </div>
            </div>
          </draggable>
        </el-form-item> -->
        <!-- <el-form-item v-show="basicInfo.isPushTerminal">
          <p style="color: #999;line-height: 22px;">按住ctrl/shift可同时批量选择多张图片上传，最多可以上传5张图片</p>
        </el-form-item> -->
        <el-form-item label="C端首页产品图片:" v-show="basicInfo.isPushTerminal">
          <input @change="spuTerminalIndexImage($event)" type="file" id="upload_C_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuTerminalIndexImage.url">
            <div class="upload_img">
              <!-- <img :src="item.url"> -->
              <el-image :src="basicInfo.spuTerminalIndexImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuTerminalIndexImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuTerminalIndexImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuTerminalIndexImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_C_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item v-show="basicInfo.isPushTerminal">
          <!-- <el-form-item v-show="basicInfo.isPushTerminal&&basicInfo.isPushTerminalIndex"> -->
          <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸400*260px</p>
        </el-form-item>
        <!-- 电子卡券图片 -->
        <el-form-item label="免单电子卡券图片:" v-show="basicInfo.isHavePromoCode">
          <input @change="spuElectronicCardImageImage($event, 'upload_card_single_img')" type="file" id="upload_card_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuElectronicCardImage.url">
            <div class="upload_img">
              <!-- <img :src="item.url"> -->
              <el-image :src="basicInfo.spuElectronicCardImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuElectronicCardImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuElectronicCardImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuElectronicCardImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_card_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="优惠电子卡券图片:" v-show="basicInfo.isHavePromoCode">
          <input @change="spuElectronicCardImageImage($event, 'upload_card_youhui_single_img')" type="file" id="upload_card_youhui_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuCouponCardImage.url">
            <div class="upload_img">
              <!-- <img :src="item.url"> -->
              <el-image :src="basicInfo.spuCouponCardImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuCouponCardImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuCouponCardImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuCouponCardImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_card_youhui_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="免费免单电子卡券图片:" v-show="basicInfo.isHavePromoCode">
          <input @change="spuElectronicCardImageImage($event, 'upload_card_free_single_img')" type="file" id="upload_card_free_single_img" style="display: none" />
          <div class="upload_warp_img_div" v-show="basicInfo.spuFreeCardImage.url">
            <div class="upload_img">
              <el-image :src="basicInfo.spuFreeCardImage.url" fit="contain" style="width:100%;height:100%" :preview-src-list="[basicInfo.spuFreeCardImage.url]"></el-image>
            </div>
            <div class="upload_warp_img_div_top">
              <p class="upload_warp_img_div_del color-blue" @click="basicInfo.spuFreeCardImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!basicInfo.spuFreeCardImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_card_free_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item v-show="basicInfo.isHavePromoCode">
          <!-- <el-form-item v-show="basicInfo.isPushTerminal&&basicInfo.isPushTerminalIndex"> -->
          <!-- <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸400*260px</p> -->
          <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸1063*1831px,300分辨率</p>
        </el-form-item>
        <el-form-item label="产品视频:">
          <div>
            <el-upload v-loading="loading" class="avatar-uploader upload_warp_left aaaaa" action="#" :http-request="httpRequest" v-bind:before-upload="beforeUploadVideo" v-bind:show-file-list="false">
              <video v-if="basicInfo.spuVideo.url !== ''" id="video" v-bind:src="basicInfo.spuVideo.url" class="avatar video-avatar" controls="controls" @canplaythrough="myFunction($event)">
                您的浏览器不支持视频播放 </video>
              <i v-else-if="basicInfo.spuVideo.url === ''" class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </el-upload>
            <div class="del_video" v-show="basicInfo.spuVideo.url" @click="basicInfo.spuVideo.url = ''">删除视频</div>
          </div>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;"> 1.尺寸:此处可使用1: 1或16: 9比例视频 <br /> 2.时长:≤60s, 建议30秒以内短视频 <br /> 3.内容:突出商品1-2个核心卖点，不建议电子相册式的图片翻页视频 </p>
        </el-form-item>
        <el-form-item label="电脑详情:" prop="pcDetail">
          <el-upload class="avatar-uploader upload_warp_left" id="uploadPcDetailImg" style="display:none" action="#" :before-upload="handleBeforeUploadPc">
          </el-upload>
          <quill-editor id="editor" class="content" :options="editorOption" @change="$refs.formRef.validateField('pcDetail')" v-model="basicInfo.pcDetail" ref="pcQuillEditor"></quill-editor>
        </el-form-item>
        <el-form-item label="移动端详情:" prop="phoneDetail">
          <el-upload class="avatar-uploader upload_warp_left" id="uploadPhoneDetailImg" style="display:none" action="#" :before-upload="handleBeforeUploadPhone">
          </el-upload>
          <quill-editor id="editor2" :options="editorOptionMobile" @change="$refs.formRef.validateField('phoneDetail')" v-model="basicInfo.phoneDetail" ref="phoneQuillEditor"></quill-editor>
        </el-form-item>
        <el-form-item label="产品模板:">
          <el-upload action="#" :http-request="unloadAccessory" :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">{{ fileName === '' ? '只能上传rar/zip文件' : '已上传：' + fileName }}</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="nextStep" v-preventReClick>下一步</el-button>
    </div>
    <!-- 查看合成区属性 -->
    <el-dialog :close-on-click-modal="false" title="查看合成区属性" :visible.sync="dialogVisible">
      <el-form ref="form" :model="areaLine" label-width="170px" inline>
        <el-form-item label="合成区:" class="address-ipt">
          <div class="area">
            <span>上：</span> {{ areaLine.areaTop }}mm
          </div>
          <div class="area">
            <span>下：</span> {{ areaLine.areaBottom }}mm
          </div>
          <div class="area">
            <span>左：</span> {{ areaLine.areaLeft }}mm
          </div>
          <div class="area">
            <span>右：</span> {{ areaLine.areaRight }}mm
          </div>
        </el-form-item>
        <el-form-item label="合成信息位置:"> {{ $config.barcodePosition[areaLine.barcodePosition] }} <el-form-item label="合成信息后是否加码:" label-width="185px">{{ areaLine.composeAfterCodeIsAppear ? '是' : '否' }}
          </el-form-item>
          <el-form-item label="左侧合成码:" label-width="115px" style="margin-left:20px;">{{ $config.leftComposeCode[areaLine.leftComposeCode] }}</el-form-item>
        </el-form-item>
        <el-form-item label="靠边:"> {{ areaLine.marginSize + 'mm' }} <el-form-item label="字号:" label-width="115px" style="margin-left:20px;">{{ areaLine.fontSize + 'px' }}</el-form-item>
        </el-form-item>
        <el-form-item label="合成区任务码:">
          <el-form-item label="宽度:" label-width="55px" style="margin-left:20px;">{{ areaLine.jobCodeWidth + 'mm' }}</el-form-item>
          <el-form-item label="高度:" label-width="55px" style="margin-left:20px;">{{ areaLine.jobCodeHeight + 'mm' }}</el-form-item>
        </el-form-item>
        <el-form-item label="裁切线设置:">{{ areaLine.cornerMargin + 'mm' }}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" v-preventReClick>确 定</el-button>
      </span>
      <!-- <createareatingtangent @save="save"></createareatingtangent> -->
    </el-dialog>
    <!-- 选择页码 -->
    <el-dialog :close-on-click-modal="false" title="选择页码" border :visible.sync="PaginationDialog" width="50%">
      <div style="width:100%;margin:0 0 10px 0">
        <span>页码名称：</span>
        <el-input style="width:200px" v-model="searchPageNumberVo.pageName" placeholder=""></el-input>
        <el-button type="primary" style="float:right;margin-right:20px" @click="(paginationQueryInfo.pageNum = 1), getPaginationList()" round>查询</el-button>
      </div>
      <el-table :data="paginationList" border style="width: 100%">
        <el-table-column prop="pageName" label="页码名称"></el-table-column>
        <el-table-column prop="startPage" label="页码起始页"></el-table-column>
        <el-table-column prop="pageNumber" label="每P页码数"></el-table-column>
        <el-table-column prop="date" label="参数" width="250px">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.pageNumberDetailList" :key="item.id"> 页码{{ index + 1 }}：{{ (item.portrait === 'top' ? '距上' : '距下') + ':' + item.portraitParam + 'mm,' +
              (item.transverse === 'left' ? '距左' : '距右') + ':' + item.transverseParam + 'mm' }} </p>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作">
          <template slot-scope="scope">
            <span @click="(selectPagnation = [scope.row]), $refs.formRef.validateField('allowPage'), (PaginationDialog = false)" class="color-blue">选择</span>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="paginationQueryInfo" @changePage="changePage"></v-pagination>
    </el-dialog>
    <!-- 选择白页 -->
    <el-dialog :close-on-click-modal="false" title="选择白页" :visible.sync="whitePageDialog" width="40%">
      <el-form :inline="true" :model="searchWhitePageVO" class="demo-form-inline">
        <el-form-item label="白页名称：">
          <el-input v-model="searchWhitePageVO.whitePageName" placeholder="" clearable></el-input>
          <el-button type="primary" @click="(whiteQueryInfo.pageNum = 1), getWhitePageList()" round>查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="whitePageList" style="width: 100%">
        <el-table-column prop="whitePageName" label="白页名称"></el-table-column>
        <el-table-column prop="date" label="白页出现位置">
          <template slot-scope="scope">
            <p> 封面：{{ scope.row.whitePageCoverPosition === 'FIRST_PAGE' ? '首页' : scope.row.whitePageCoverPosition === 'LAST_PAGE' ? '尾页' : scope.row.whitePageCoverPosition === 'FIRST_LAST_PAGE' ?
              '首页,尾页' : scope.row.whitePageCoverPosition === 'NO_PAGE' ? '无' : scope.row.whitePageCoverPosition === 'AFTER_ADD1_PAGE' ? '每P后+1P白' : '未定义' }} </p>
            <p> 内页：{{ scope.row.whitePageTextPosition === 'FIRST_PAGE' ? '首页' : scope.row.whitePageTextPosition === 'LAST_PAGE' ? '尾页' : scope.row.whitePageTextPosition === 'FIRST_LAST_PAGE' ? '首页,尾页'
              : scope.row.whitePageTextPosition === 'NO_PAGE' ? '无' : scope.row.whitePageTextPosition === 'AFTER_ADD1_PAGE' ? '每P后+1P白' : '未定义' }} </p>
            <p> 单页：{{ scope.row.whitePageSinglePosition === 'FIRST_PAGE' ? '首页' : scope.row.whitePageSinglePosition === 'LAST_PAGE' ? '尾页' : scope.row.whitePageSinglePosition === 'FIRST_LAST_PAGE' ?
              '首页,尾页' : scope.row.whitePageSinglePosition === 'NO_PAGE' ? '无' : scope.row.whitePageSinglePosition === 'AFTER_ADD1_PAGE' ? '每P后+1P白' : '未定义' }} </p>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="操作">
          <template slot-scope="scope">
            <span @click="(selectWhitePage = [scope.row]), $refs.formRef.validateField('allowWhitePage'), (whitePageDialog = false)" class="color-blue">选择</span>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="whiteQueryInfo" @changePage="whiteChangePage"></v-pagination>
    </el-dialog>
    <!-- 选择属性 -->
    <el-dialog :close-on-click-modal="false" title="选择属性" :visible.sync="choiceAttrDialog" width="30%">
      <el-table :data="allAttrList" ref="multipleTable" border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="propKey" label="属性名"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddAttr" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择产品标签 -->
    <el-dialog :close-on-click-modal="false" title="选择标签" :visible.sync="choiceTagDialog" width="30%">
      <el-table :data="allTagList" ref="tagTable" border style="width: 100%" @selection-change="handleTagChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="label" label="标签"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAddTag" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import createareatingtangent from '@/components/RightContent/HQAdmin/ProductManagement/CreateCuttingTangent/index.vue'
import $ from 'jquery'
import draggable from 'vuedraggable'
import VPagination from '@/components/Pagination/index.vue'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { addQuillTitle } from '@/assets/js/quill.js'
import {
  areaList,
  areaUsable,
  machineCodeListNoPage,
  labelGetLabelList,
  areaAdd,
  spuUsable,
  whitePageList,
  spuProperty,
  areaDetail,
  dictListNoPaging,
  pageNumberGetPageNumberList,
  areaUpdate,
  spuSeriesAdd,
  categoryQuerySubs,
  propertyList,
  categoryList,
  categoryGet,
  dictUsable,
  spuAdd,
  spuType
} from '@/api/pms'
export default {
  name: 'edit-product',
  components: {
    VPagination,
    draggable
    // createareatingtangent
  },
  data () {
    const toolbarOptions = [
      ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
      ['blockquote', 'code-block'], // 引用，代码块
      [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
      [{ list: 'ordered' }, { list: 'bullet' }], // 列表
      [{ script: 'sub' }, { script: 'super' }], // 上下标
      [{ indent: '-1' }, { indent: '+1' }], // 缩进
      [{ direction: 'rtl' }], // 文本方向
      [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
      [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
      [{ font: [] }], // 字体
      [{ align: [] }], // 对齐方式
      ['clean'], // 清除字体样式
      ['image', 'video'] // 上传图片、上传视频
    ]
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('产品名称不能为空'))
      }
      // if (value.length > 40) {
      //   return callback(new Error('产品名称长度不能大于40'))
      // }
      var flag = new RegExp(this.$reg.name.reg)
      if (flag.test(value)) {
        return callback(new Error(this.$reg.name.message))
      }
      callback()
    }
    var checkCategory = (rule, value, callback) => {
      // if (this.category.categoryId !== '') {
      //   array.forEach(element => {

      //   });
      // }
      if (this.category.ownCategoryId === '') {
        return callback(new Error('未选择产品类别'))
      } else {
        callback()
      }
    }
    var COVER = (rule, value, callback) => {
      if (this.spuComposeAreaList.COVER.composeArea.leftComposeCode === 'MACHINE_CODE' && !this.spuComposeAreaList.COVER.machineCodeId) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var SINGLE = (rule, value, callback) => {
      if (this.spuComposeAreaList.SINGLE.composeArea.leftComposeCode === 'MACHINE_CODE' && !this.spuComposeAreaList.SINGLE.machineCodeId) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var TEXT = (rule, value, callback) => {
      if (this.spuComposeAreaList.TEXT.composeArea.leftComposeCode === 'MACHINE_CODE' && !this.spuComposeAreaList.TEXT.machineCodeId) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var checkMachineCodeId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('未选择机器码'))
      } else {
        callback()
      }
    }
    var checkPrimaryImages = (rule, value, callback) => {
      if (this.category.ownCategoryId.id == 10 || this.category.ownCategoryId.id == 13) {
        if (this.basicInfo.primaryImages.length < 3 || this.basicInfo.primaryImages.length > 10) {
          return callback(new Error('需要上传3-10张图片'))
        } else {
          callback()
        }
      } else {
        if (this.basicInfo.primaryImages.length === 0) {
          return callback(new Error('未上传图片'))
        } else {
          callback()
        }
      }
    }
    var checkTagList = (rule, value, callback) => {
      if (this.tagList.length === 0) {
        return callback(new Error('请选择标签'))
      } else {
        callback()
      }
    }
    var checkAttrList = (rule, value, callback) => {
      if (this.attrList.length === 0) {
        return callback(new Error('请选择属性'))
      } else {
        callback()
      }
    }
    var checkTop = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距上规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkBottom = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距下规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkLeft = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距左规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkRight = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入距右规格'))
      } else if (value < 0) {
        return callback(new Error('请输入大于等于0的值'))
      } else if (!this.$reg.area.reg.test(value)) {
        return callback(this.$reg.area.message)
      } else {
        callback()
      }
    }
    var checkWhitePage = (rule, value, callback) => {
      if (this.allowWhitePage && this.selectWhitePage.length === 0) {
        callback(new Error('请选择白页'))
      } else {
        callback()
      }
    }
    var checkPage = (rule, value, callback) => {
      if (this.allowPage && this.selectPagnation.length === 0) {
        callback(new Error('请选择页码'))
      } else {
        callback()
      }
    }
    return {
      isDiyDisable: false,
      spuComposeAreaList: {
        COVER: {
          composeArea: {},
          machineCodeId: ''
        },
        SINGLE: {
          composeArea: {},
          machineCodeId: ''
        },
        TEXT: {
          composeArea: {},
          machineCodeId: ''
        }
      },
      machineCodeList: [],
      fileName: '',
      tagList: [],
      allTagList: [],
      choiceTagDialog: false,
      addAreaLineName: '',
      loading: false,
      choiceAttrList: [],
      choiceTagList: [],
      allAttrList: [],
      choiceAttrDialog: false,
      whiteQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
      },
      paginationQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
      },
      tagQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
      },
      searchWhitePageVO: {
        whitePageName: ''
      },
      tableData: [],
      searchPageNumberVo: {
        page: 1,
        pageName: ''
      },
      PaginationDialog: false,
      whitePageDialog: false,
      dialogVisible: false,
      category: {
        ownCategoryId: '',
        topCategoryId: '',
        subCategoryId: '',
        categoryId: ''
      },
      frontFile: {
        pdfName: '',
        fixedUrl: ''
      },
      afterFile: {
        pdfName: '',
        fixedUrl: ''
      },
      onlineDesign: [], // 在线设计
      basicInfo: {
        discountBundle: 0, // 折扣包
        specialLayout: 0, // 特殊排版
        startupsSpu: 0,
        spuAttachmentUrl: '',
        allowMatchSize: true,
        uploadPdf: false,
        isHidden: false,
        isPushSaas: false,
        isHavePromoCode: false,
        isPushTerminal: false,
        isCommemorationDay: false,
        // isPushTerminalIndex: false,
        isPdf: false,
        spuFixedPdfList: [],
        pdfFixedNums: '',
        isModifyPdfSize: false,
        pdfPosition: '',
        pdfTemplateNums: '',
        pdfNoComposePage: '',
        isDiy: false,
        singlePrice: false, // 价格是否唯一
        isSingleSkuGroup: false,
        isCloudDesign: true,
        topParam: null,
        leftParam: null,
        coverPosition: '',
        categoryId: '',
        areaId: '',
        machineCodeId: '',
        dictIdSet: [],
        pcDetail: '',
        phoneDetail: '',
        primaryImages: [],
        primaryAppImages: [],
        spuTerminalIndexImage: {
          url: ''
        },
        // 免单电子卡券
        spuElectronicCardImage: {
          url: ''
        },
        // 优惠电子卡券
        spuCouponCardImage: {
          url: ''
        },
        // 免费免单电子卡券
        spuFreeCardImage: {
          url: ''
        },
        spuTerminalPrimaryImages: [],
        spuPdfAddPageVO: [],
        spuDpi: 300,
        spuProperty: '',
        spuType: '',
        spuDesc: '',
        spuName: '',
        spuVideo: {
          mimetype: '',
          sortOrder: 0,
          url: ''
        },
        whitePageId: '',
        textPageCodeId: ''
      },
      allowPage: false,
      allowWhitePage: false,
      arrList: [],
      editorOptionMobile: {
        placeholder: '请编辑内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#uploadPhoneDetailImg input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      editorOption: {
        theme: 'snow',
        placeholder: '请编辑内容',
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector('#uploadPcDetailImg input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      videoFlag: false, // 是否显示进度条
      videoUploadPercent: '', // 进度条的进度，
      isShowUploadVideo: false, // 显示上传按钮
      rules: {
        ownCategoryId: [{ validator: checkCategory, trigger: 'change' }],
        spuName: [{ validator: checkName, trigger: 'blur' }],
        spuDesc: [
          {
            required: true,
            message: '请填写产品描述'
          },
          {
            message: '产品描述不能超过50个字符',
            min: 1,
            max: 50
          }
        ],
        spuProperty: [
          {
            required: true,
            message: '请选择产品性质'
          }
        ],
        COVER: [{ validator: COVER, trigger: 'blur' }],
        SINGLE: [{ validator: SINGLE, trigger: 'blur' }],
        TEXT: [{ validator: TEXT, trigger: 'blur' }],
        // machineCodeId: [
        //   { required: true, validator: checkMachineCodeId }
        // ],
        spuDpi: [{ required: true, message: '请选择产品分辨率', trigger: 'change' }],
        allowWhitePage: [{ validator: checkWhitePage }],
        allowPage: [{ validator: checkPage }],
        phoneDetail: [
          {
            required: true,
            message: '请填写移动端详情'
          }
        ],
        pcDetail: [
          {
            required: true,
            message: '请填写电脑详情'
          }
        ],
        primaryImages: [{ validator: checkPrimaryImages, trigger: 'change' }],
        attrList: [{ validator: checkAttrList }]
        // tagList: [
        //   { validator: checkTagList }
        // ]
      },
      queryId: '',
      productypeList: [
        {
          id: '',
          dictValue: '',
          dictCode: ''
        }
      ],
      natureList: [],
      typeFirst: [],
      typeSecond: [],
      typeThird: [],
      typeFourth: [],
      attrList: [],
      areaList: [],
      topBottom: '',
      topSubBottom: '',
      topThirdBottom: '',
      areaLine: {},
      whitePageList: [],
      selectWhitePage: [],
      selectPagnation: [],
      paginationList: [],
      options: [
        {
          value: '上',
          label: '上'
        },
        {
          value: '下',
          label: '下'
        },
        {
          value: '左',
          label: '左'
        },
        {
          value: '右',
          label: '右'
        }
      ],
      areatingInfo: {
        barcodePosition: '',
        areaBottom: '',
        areaLeft: '',
        areaName: '',
        areaRight: '',
        areaTop: ''
      },
      createRules: {
        areaName: [{ required: true, message: '请输入合成区区域名称', trigger: 'blur' }],
        areaTop: [{ validator: checkTop, trigger: 'blur' }],
        areaBottom: [{ validator: checkBottom, trigger: 'blur' }],
        areaLeft: [{ validator: checkLeft, trigger: 'blur' }],
        areaRight: [{ validator: checkRight, trigger: 'blur' }],
        barcodePosition: [{ required: true, message: '请选择条码位置', trigger: 'change' }]
      },
      awsSdk: {}
    }
  },
  mounted () {
    addQuillTitle('editor')
    addQuillTitle('editor2')
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getTagList()
    // this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    if (this.$route.query.content) {
      this.handleMsg()
    }
    this.queryId = this.$route.query.id
    this.getProNature()
    this.getProCate()
    this.getAreaType()
    this.getSpuAttrList()
    this.machineCodeListNoPage()
    this.getProType()
  },
  computed: {
    getMaxImg () {
      let num = (this.category.ownCategoryId.id == 10 || this.category.ownCategoryId.id == 13) ? 10 : 5
      return num
    }
  },
  methods: {
    // pdf按钮
    isPdfChange (val) {
      console.log('vaaaallll', val)
      if (val) {
        this.basicInfo.isDiy = false
        this.isDiyDisable = true
      } else {
        this.isDiyDisable = false
      }
    },
    // 上产PDF文件位置
    uploadFilePdf (e, key) {
      console.log(e, key)
      let file = e.file
      if (file.type !== 'application/pdf') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (e) => {
      }).then(res => {
        if (res === 'error') {
          this.$message.error('服务器问题，请刷新页面重试或联系管理员')
          return
        }
        console.log(res, '11111')
        if (key === 'front') {
          this.frontFile.fixedUrl = res
          this.frontFile.pdfName = file.name
        } else {
          this.afterFile.fixedUrl = res
          this.afterFile.pdfName = file.name
        }
        // this.$forceUpdate()
      })
    },
    deletePdf (type) {
      if (type === 'after') {
        this.afterFile.pdfName = ''
        this.afterFile.fixedUrl = ''
      } else {
        this.frontFile.pdfName = ''
        this.frontFile.fixedUrl = ''
      }
    },
    // 打开纪念日台历是否云端设计关闭
    onComDay () {
      // console.log('this.basicInfo.isCommemorationDay', this.basicInfo.isCommemorationDay)
      if (this.basicInfo.isCommemorationDay) {
        this.basicInfo.isCloudDesign = false
      }
    },
    machineCodeListNoPage () {
      machineCodeListNoPage().then(res => {
        if (res.data.success) {
          this.machineCodeList = res.data.data
        }
      })
    },
    getTagList () {
      labelGetLabelList({ pageNum: this.tagQueryInfo.pageNum, pageSize: this.tagQueryInfo.pageSize, searchLabelVo: { page: 0 } }).then(res => {
        if (res.data.success) {
          this.allTagList = res.data.data.records
          this.tagQueryInfo.total = res.data.data.total
        }
      })
    },
    unloadAccessory (data) {
      let file = data.file
      let fileType = file.name.slice(file.name.lastIndexOf('.'))
      if (fileType !== '.rar' && fileType !== '.zip') {
        this.$message.error('请上传正确的模板格式')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.basicInfo.spuAttachmentUrl = res
        this.fileName = file.name
      })
    },
    areaClosed () {
      this.areatingInfo = {
        barcodePosition: '',
        areaBottom: '',
        areaLeft: '',
        areaName: '',
        areaRight: '',
        areaTop: ''
      }
      this.$refs.createForm.resetFields()
    },
    unchoose () {
      this.basicInfo.primaryImages.forEach((item, index) => {
        item.sortOrder = index
      })
    },
    asd () { },

    qwe () { },
    // 获取合成区详情
    getAreaLineDetail (id) {
      areaDetail(id).then(res => {
        if (res.data.success) {
          this.areaLine = res.data.data
        }
      })
    },
    // 处理传入的产品数据
    handleMsg () {
      this.tagList = JSON.parse(this.$route.query.tagList)
      let obj = JSON.parse(this.$route.query.content)
      obj.spuName = ''
      obj.spuDesc = ''

      if (this.$route.query.id === '0') {
        if (obj.spuAreaLine) {
          this.getAreaLineDetail(obj.spuAreaLine.id)
        }
        this.attrList = obj.spuDictList
      }

      if (obj.category.ownCategory !== '') {
        this.category.ownCategoryId = obj.category.ownCategory
        this.getTypeSecond()
      }
      if (obj.category.topCategory !== '') {
        this.category.topCategoryId = obj.category.topCategory
        this.getTypeThird()
      }
      if (obj.category.subCategory !== '') {
        this.category.subCategoryId = obj.category.subCategory
        this.getTypeFourth()
      }
      if (obj.category.category !== '') {
        this.category.categoryId = obj.category.category
      }

      this.allowWhitePage = !!obj.whitePageId
      if (obj.whitePageId) {
        this.selectWhitePage = [obj.whitePage]
      }
      this.allowPage = !!obj.pageNumber
      if (obj.pageNumber) {
        this.selectPagnation = [obj.pageNumber]
      }
      this.basicInfo = obj
    },
    // 上传产品phone端详情图片之前
    handleBeforeUploadPhone (file) {
      let _this = this
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          var width = img.width
          if (width > 960) {
            _this.$message.error('图片宽度不能大于960')
          } else {
            _this.uploadPhoneDetailImg(file)
          }
          // 在这里可以执行其他需要图片尺寸信息的操作
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
      return false // 阻止默认上传行为
    },
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    // 上传产品PC端详情图片之前
    handleBeforeUploadPc (file) {
      let _this = this
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.onload = () => {
          console.log('图片宽度:', img.width)
          console.log('图片高度:', img.height)
          var width = img.width
          // var height = img.height
          if (width > 960) {
            _this.$message.error('图片宽度不能大于960')
            return false
          } else {
            _this.uploadPcDetailImg(file)
          }
        }
        img.src = e.target.result
      }
      reader.readAsDataURL(file)
      return false // 阻止默认上传行为
    },
    // 上传产品PC端详情图片
    uploadPcDetailImg (file) {
      console.log('上传产品PC端详情图片', file)
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.pcQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    saveAddTag () {
      this.tagList = JSON.parse(JSON.stringify(this.choiceTagList))
      this.$refs.tagTable.clearSelection()
      this.$refs.formRef.validateField('tagList')
      this.choiceTagDialog = false
    },
    saveAddAttr () {
      this.attrList = JSON.parse(JSON.stringify(this.choiceAttrList))
      this.$refs.multipleTable.clearSelection()
      this.$refs.formRef.validateField('attrList')
      this.choiceAttrDialog = false
    },
    // 获取产品属性列表
    getSpuAttrList () {
      dictListNoPaging(-1).then(res => {
        if (res.data.success) {
          this.allAttrList = res.data.data
        }
      })
    },
    // 创建合成区
    save (areaName) {
      this.addAreaLineName = areaName
      this.dialogVisible = false
      this.getAreaType()
      // this.$refs.createForm.validate((valid) => {
      //   if (!valid) {
      //     return
      //   }
      //   areaUsable({
      //     act: 0,
      //     areaName: this.areatingInfo.areaName
      //   }).then((res) => {
      //     if (res.data.success) {
      //       areaAdd(this.areatingInfo).then((res) => {
      //         if (res.data.success) {
      //           this.$message.success('新建合成区类型成功')
      //           this.addAreaLineName = this.areatingInfo.areaName
      //           this.dialogVisible = false
      //           this.getAreaType()
      //         }
      //       })
      //     }
      //   })
      // })
    },
    // 查询页码
    getPaginationList () {
      pageNumberGetPageNumberList({
        pageNum: this.paginationQueryInfo.pageNum,
        pageSize: this.paginationQueryInfo.pageSize,
        searchPageNumberVo: this.searchPageNumberVo
      }).then(res => {
        if (res.data.success) {
          this.paginationList = res.data.data.records
          this.paginationQueryInfo.total = res.data.data.total
        }
      })
    },
    // 查询白页
    getWhitePageList () {
      whitePageList({ pageNum: this.whiteQueryInfo.pageNum, pageSize: this.whiteQueryInfo.pageSize, searchWhitePageVO: this.searchWhitePageVO }).then(res => {
        if (res.data.success) {
          this.whiteQueryInfo.total = res.data.data.total
          this.whitePageList = res.data.data.records
        }
      })
    },
    addArea () {
      this.dialogVisible = false
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 获取产品类
    getProCate () {
      categoryList().then(res => {
        this.typeFirst = res.data.data
      })
    },
    // 获取产品类型
    getProType () {
      spuType('SPU_TYPE').then(res => {
        this.productypeList = res.data.data
      })
    },
    getProNature () {
      // 获取产品性质
      spuProperty().then(res => {
        this.natureList = res.data.data
      })
    },
    // 获取合成区类型
    getAreaType () {
      areaList().then(res => {
        if (res.data.success) {
          this.areaList = res.data.data
          if (this.addAreaLineName !== '') {
            res.data.data.forEach(item => {
              // if (item.areaName === this.addAreaLineName) {
              //   this.setArea(item)
              //   this.areaLine = item
              //   this.$refs.formRef.validateField('areaId')
              // }
            })
          }
        }
      })
    },
    setArea (val) {
      this.basicInfo.composeAreaId = val === '' ? '' : val.id
    },

    // 获取二级产品类别
    getTypeSecond () {
      let num = this.category.ownCategoryId.id
      if (num === undefined) {
        this.category.topCategoryId = ''
        this.category.subCategoryId = ''
        this.category.categoryId = ''
        this.typeSecond = []
        this.typeThird = []
        this.typeFourth = []
        return false
      }
      categoryQuerySubs(num).then(res => {
        if (res.data.success) {
          this.typeSecond = res.data.data
          if (this.category.topCategoryId) {
            let num = res.data.data.filter(item => {
              return item.id === this.category.topCategoryId.id
            })
            if (num.length === 0) {
              this.category.topCategoryId = ''
              this.category.subCategoryId = ''
              this.category.categoryId = ''
              this.typeThird = []
              this.typeFourth = []
            }
          }
        }
      })
    },
    // 获取三级产品类别
    getTypeThird () {
      let num = this.category.topCategoryId.id
      if (num === undefined) {
        this.category.subCategoryId = ''
        this.category.categoryId = ''
        this.typeThird = []
        this.typeFourth = []
        return false
      }
      this.topBottom = 0
      categoryQuerySubs(num).then(res => {
        if (res.data.success) {
          this.typeThird = res.data.data
          if (this.category.subCategoryId) {
            let num = res.data.data.filter(item => {
              return item.id === this.category.subCategoryId.id
            })
            if (num.length === 0) {
              this.category.subCategoryId = ''
              this.category.categoryId = ''
              this.typeFourth = []
            }
          }
        }
      })
    },
    // 获取四级产品类别
    getTypeFourth () {
      let num = this.category.subCategoryId.id
      if (num === undefined) {
        this.category.categoryId = ''
        this.typeFourth = []
        return false
      }
      this.topBottom = 0
      categoryQuerySubs(num).then(res => {
        if (res.data.success) {
          this.typeFourth = res.data.data
          if (this.category.categoryId) {
            let num = res.data.data.filter(item => {
              return item.id === this.category.categoryId.id
            })
            if (num.length === 0) {
              this.category.categoryId = ''
            }
          }
        }
      })
    },
    // 判断是不是底层类
    checkCategory (categoryId, type) {
      this.attrList = []
      categoryGet(categoryId).then(res => {
        if (res.data.success) {
          if (res.data.data.bottom === 1) {
            this.basicInfo.dictIdSet = []
            this.attrList = res.data.data.dicts
            this.attrList.forEach(item => {
              this.basicInfo.dictIdSet.push(item.id)
              if (item.isMallShow === 1) {
                item.isMallShow = '是'
              }
              if (item.isMallShow === 0) {
                item.isMallShow = '否'
              }
            })
            if (type === 0) {
              this.topBottom = 1
            }
            if (type === 1) {
              this.topSubBottom = 1
            }
          }
        }
      })
    },
    // 检查产品名称是否重复
    getProName () {
      dictUsable(this.basicInfo.spuName).then(res => { })
    },
    fileClick (id) {
      if (id === 'upload_C_single_img') {
        document.getElementById('upload_C_single_img').value = null
        document.getElementById('upload_C_single_img').click()
        return
      }
      if (id === 'upload_card_single_img') {
        document.getElementById('upload_card_single_img').value = null
        document.getElementById('upload_card_single_img').click()
        return
      }
      if (id === 'upload_card_youhui_single_img') {
        document.getElementById('upload_card_youhui_single_img').value = null
        document.getElementById('upload_card_youhui_single_img').click()
        return
      }
      if (id === 'upload_card_free_single_img') {
        document.getElementById('upload_card_free_single_img').value = null
        document.getElementById('upload_card_free_single_img').click()
        return
      }
      if (this.category.ownCategoryId.id == 10 || this.category.ownCategoryId.id == 13) {
        if (this.basicInfo.primaryImages.length > 10) {
          this.$message.warning('最多可上传10张图片')
          return
        }
      } else {
        if (this.basicInfo.primaryImages.length > 5) {
          this.$message.warning('已上传5张图片')
          return
        }
      }
      if (this.basicInfo.spuPdfAddPageVO.length > 3) {
        this.$message.warning('已上传3张图片')
        return
      }
      if (this.basicInfo.primaryAppImages.length > 5) {
        this.$message.warning('已上传5张图片')
        return
      }
      document.getElementById(id).click()
    },
    fileChange (el, listName) {
      console.log('el', listName, el.target.files)
      if (this.category.ownCategoryId.id == 10 || this.category.ownCategoryId.id == 13) {
        if (this.basicInfo[listName].length > 10) return
      } else {
        if (this.basicInfo[listName].length > 5) return
      }
      this.fileList(el.target.files, listName)
      el.target.value = ''
    },
    fileList (files, listName) {
      console.log('listName', listName)
      if (listName == 'spuPdfAddPageVO') {
        if (files.length > 3 || files.length + this.basicInfo[listName].length > 3) {
          this.$message.warning('最多上传3张图片')
          return
        }
      } else if (listName == 'primaryImages') {
        if (this.category.ownCategoryId.id == 10 || this.category.ownCategoryId.id == 13) {
          if (files.length > 10 || files.length + this.basicInfo[listName].length > 10) {
            this.$message.warning('最多上传10张图片')
            return
          }
        } else {
          if (files.length > 5 || files.length + this.basicInfo[listName].length > 5) {
            this.$message.warning('最多上传5张图片')
            return
          }
        }
      } else {
        if (files.length > 5 || files.length + this.basicInfo[listName].length > 5) {
          this.$message.warning('最多上传5张图片')
          return
        }
      }
      for (let i = 0; i < files.length; i++) {
        console.log('files[i]', files[i])
        this.fileSize(files[i], listName)
      }
      // this.basicInfo[listName] = this.basicInfo[listName].sort((a, b) => a.sortOrder - b.sortOrder)
      console.log('this.basicInfo[listName', this.basicInfo[listName])
    },
    fileSize (file, listName) {
      console.log('上传类型', listName)
      // var isAllow = fasle
      // 读取图片数据
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        console.log('e', e)
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = async function () {
          console.log('image', image.width, image.height)
          var width = image.width
          var height = image.height
          if (listName == 'primaryImages') {
            if (_this.category.ownCategoryId.id !== 10 && _this.category.ownCategoryId.id !== 13) {
              if (width === height) {
                await _this.fileAdd(file, listName)
              } else {
                _this.$message.error('图片长宽不相同')
              }
            } else {
              // if (width == 960 && height == 1080) {
              await _this.fileAdd(file, listName)
              // } else {
              //   _this.$message.error('图片长宽需要960*1080')
              // }
            }
          } else if (listName == 'spuPdfAddPageVO') {
            await _this.fileAdd(file, listName)
          } else {
            if (width / height === 3 / 4) {
              await _this.fileAdd(file, listName)
            } else {
              _this.$message.error('图片长宽不是3:4')
            }
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    async fileAdd (file, listName) {
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/svg', 'image/svg+xml', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      console.log(this.$store.state.awsSdk.product.s3)
      await uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], precent => { }, 280, 280).then(res => {
        this.basicInfo[listName].push({
          url: res,
          mimetype: file.type,
          sortOrder: this.basicInfo[listName].length
        })
        this.$refs.formRef.validateField(listName)
      })
      // this.size = this.size + file.size// 总大小
    },
    spuTerminalIndexImage (e) {
      console.log('c端上传图片')
      console.log(e, 'spuTerminalIndexImage')
      let file = e.target.files[0]
      console.log(file, 'sssssss')
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], precent => { }, 280, 280).then(res => {
        this.basicInfo.spuTerminalIndexImage = {
          url: res,
          mimetype: file.type,
          sortOrder: 0
        }
      })
    },
    // 上传电子卡券
    spuElectronicCardImageImage (e, type) {
      console.log('上传电子卡券')
      let file = e.target.files[0]
      // if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(file.type) === -1) {
      //   this.$message.warning('请上传png,jpg,jpeg格式的图片')
      //   return false
      // }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], precent => { }, 280, 280).then(res => {
        if (type === 'upload_card_single_img') {
          this.basicInfo.spuElectronicCardImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        } else if (type === 'upload_card_free_single_img') {
          this.basicInfo.spuFreeCardImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        } else {
          this.basicInfo.spuCouponCardImage = {
            url: res,
            mimetype: file.type,
            sortOrder: 0
          }
        }
      })
    },
    fileDel (index, listName) {
      // this.size = this.size - this.basicInfo.primaryImages[index].file.size// 总大小
      this.basicInfo[listName].splice(index, 1)
      this.addImageIndex(listName)
    },
    addImageIndex (listName) {
      this.basicInfo[listName].forEach((item, index) => {
        item.sortOrder = index
      })
    },
    // 设为主图
    fileMain (index, listName) {
      let imgList = this.basicInfo[listName]
      let img = imgList[index]
      imgList.splice(index, 1)
      imgList.unshift(img)
      this.addImageIndex(listName)
    },
    // 上传前回调
    beforeUploadVideo (file) {
      // var fileSize = file.size / 1024 / 1024 < 50
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的视频格式')
        return false
      }
      this.isShowUploadVideo = false
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    httpRequest (data) {
      this.loading = true

      uploadWebImg(data.file, this.$store.state.awsSdk.product.s3, [], () => { }, 150, 150).then(res => {
        this.basicInfo.spuVideo.url = res
        this.basicInfo.spuVideo.mimetype = data.file.type
        this.basicInfo.spuVideo.sortOrder = 0
        this.loading = false
      })
    },
    myFunction () {
      let ele = $('#video')
      let _this = this
      // var hour = parseInt((ele.duration) / 3600)
      // var second = Math.ceil(ele.duration % 60)
      var i = setInterval(function () {
        // if (ele.readyState > 0) {
        var minutes = parseInt(ele[0].duration / 60, 10)
        if (minutes > 0) {
          _this.$message.error('视频时长不能超过60s')
          _this.basicInfo.spuVideo.url = ''
        }
        clearInterval(i)
        // }
      }, 200)
    },
    addNature () {
      this.getProNature()
    },
    nextStep () {
      if (this.basicInfo.isPushTerminal && this.basicInfo.spuTerminalIndexImage.url === '') {
        this.$message.error('请上传C端首页产品图片')
        return
      }
      if (this.basicInfo.isHavePromoCode && this.basicInfo.spuElectronicCardImage.url === '') {
        this.$message.error('请上传免单电子卡券图片')
        return
      }
      if (this.basicInfo.isHavePromoCode && this.basicInfo.spuCouponCardImage.url === '') {
        this.$message.error('请上传优惠电子卡券图片')
        return
      }
      // if (this.basicInfo.isHavePromoCode && this.basicInfo.spuFreeCardImage.url === '') {
      //   this.$message.error('请上传免费免单电子卡券图片')
      //   return
      // }
      if (
        !Object.keys(this.spuComposeAreaList).some(page => {
          return !!this.spuComposeAreaList[page].composeArea.id
        }) &&
        this.basicInfo.spuProperty === 'CUSTOM' &&
        +this.$route.query.id === 0
      ) {
        this.$message.error('合成区至少选一个')
        return
      }
      if (this.basicInfo.spuPdfAddPageVO.length > 0 && this.basicInfo.spuPdfAddPageVO.length < 3) {
        this.$message.error('请上传补页3张，或者不传')
        return
      }
      // 在线设计
      if (this.onlineDesign.length == 1) {
        this.basicInfo.onlineDesign = this.onlineDesign[0]
      } else if (this.onlineDesign.length == 2 && this.onlineDesign.includes(1)) {
        this.basicInfo.onlineDesign = 3
      } else if (this.onlineDesign.length == 2 && this.onlineDesign.includes(4)) {
        this.basicInfo.onlineDesign = 5
      } else {
        this.basicInfo.onlineDesign = 0
      }
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          setTimeout(_ => {
            var isError = document.getElementsByClassName('is-error')

            isError[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
          }, 0)
          return false
        }
        spuUsable({ act: 0, spuName: this.basicInfo.spuName }).then(res => {
          if (!res.data.success) {
            return
          }
          if (this.basicInfo.spuProperty === 'CUSTOM') {
            this.basicInfo.topCategoryId = this.category.ownCategoryId === '' ? '' : this.category.ownCategoryId.id
            this.basicInfo.firstCategoryId = this.category.topCategoryId === '' ? '' : this.category.topCategoryId.id
            this.basicInfo.secondCategoryId = this.category.subCategoryId === '' ? '' : this.category.subCategoryId.id
            this.basicInfo.threeCategoryId = this.category.categoryId === '' ? '' : this.category.categoryId.id
            console.log('this.category', this.category)
            for (let k in this.category) {
              if (this.category[k].categoryName === 'VIP' || this.category[k].bottom || this.category[k].level === 3) {
                this.basicInfo.categoryId = this.category[k].id
              }
            }
            if (this.category.ownCategoryId.id == 8 ||
              this.category.ownCategoryId.id == 13) {
              this.basicInfo.categoryId = this.category.ownCategoryId.id
            }
            console.log('this.category.ownCategoryId.id', this.category.ownCategoryId.id)
            if (this.category.ownCategoryId.id != 8 &&
              this.category.ownCategoryId.id != 13 &&
              this.basicInfo.categoryId === '') {
              this.$message.error('未选择最底层类')
              return
            }

            let spuComposeAreaList = []

            Object.keys(this.spuComposeAreaList).forEach(page => {
              if (this.spuComposeAreaList[page].composeArea.id) {
                spuComposeAreaList.push({
                  composeAreaId: this.spuComposeAreaList[page].composeArea.id,
                  machineCodeId: this.spuComposeAreaList[page].composeArea.leftComposeCode === 'MACHINE_CODE' ? this.spuComposeAreaList[page].machineCodeId : '',
                  pageTypeCode: page
                })
              }
            })
            this.basicInfo.spuComposeAreaList = spuComposeAreaList

            let arr = []
            this.attrList.forEach(attr => {
              arr.push(attr.id)
            })
            let spuTags = []
            this.tagList.forEach(tag => {
              spuTags.push(tag.label)
            })
            this.basicInfo.spuTags = spuTags.join(' ')
            // this.basicInfo.topCategoryId = topCategoryId
            this.basicInfo.dictIdSet = arr
            this.basicInfo.whitePageId = this.allowWhitePage ? this.selectWhitePage[0].id : ''
            this.basicInfo.textPageCodeId = this.allowPage ? this.selectPagnation[0].id : ''
            // pdf 前后文件
            let spuFixedPdfList = []
            if (this.frontFile.fixedUrl) {
              spuFixedPdfList.push({ ...this.frontFile, position: 'FRONT' })
            }
            if (this.afterFile.fixedUrl) {
              spuFixedPdfList.push({ ...this.afterFile, position: 'AFTER' })
            }
            // 上传补页
            let spuPdfAddPage = {}
            this.basicInfo.spuPdfAddPageVO.forEach((item, index) => {
              if (index == 0) {
                spuPdfAddPage.firstPage = item.url
              } else if (index == 1) {
                spuPdfAddPage.secondPage = item.url
              } else if (index == 2) {
                spuPdfAddPage.thirdPage = item.url
              }
            })
            this.basicInfo.spuPdfAddPageVO = spuPdfAddPage
            let _this = this
            if (+_this.$route.query.id === 0) {
              console.log('this.basicInfo', _this.basicInfo)
              spuAdd(_this.basicInfo).then(res => {
                if (res.data.success) {
                  // let startupsSpu = res.data.data.startupsSpu
                  let startupsSpu = false
                  if (res.data.data.topCategoryId == 10) {
                    startupsSpu = true
                  } else {
                    startupsSpu = false
                  }
                  _this.$router.push({
                    path: './createnewsku',
                    query: {
                      categoryId: _this.category.ownCategoryId.id,
                      spuProperty: _this.basicInfo.spuProperty,
                      list: _this.basicInfo.dictIdSet,
                      id: res.data.data.id,
                      hasWhitePage: _this.allowWhitePage,
                      isVip: _this.category.ownCategoryId.id === 4,
                      spuName: _this.basicInfo.spuName,
                      isSingleSkuGroup: _this.basicInfo.isSingleSkuGroup,
                      isDiy: _this.basicInfo.isDiy,
                      isHavePromoCode: _this.basicInfo.isHavePromoCode,
                      spuType: _this.basicInfo.spuType,
                      startupsSpu: startupsSpu,
                      showPoint: _this.category.ownCategoryId.id == 13
                    }
                  })
                }
              })
            } else if (+this.$route.query.id === 1) {
              spuSeriesAdd(this.basicInfo).then(res => {
                if (res.data.success) {
                  // let startupsSpu = res.data.data.startupsSpu
                  let startupsSpu = false
                  if (res.data.data.topCategoryId == 10) {
                    startupsSpu = true
                  } else {
                    startupsSpu = false
                  }
                  // this.$message.success('')
                  this.$router.push({
                    path: './createsyssku',
                    query: {
                      categoryId: this.category.ownCategoryId.id,
                      spuProperty: this.basicInfo.spuProperty,
                      spuId: res.data.data.id,
                      startupsSpu: startupsSpu,
                      showPoint: this.category.ownCategoryId.id == 13
                    }
                  })
                }
              })
            }
          } else if (this.basicInfo.spuProperty === 'NORMAL') {
            let topCategoryId = this.category.ownCategoryId === '' ? '' : this.category.ownCategoryId.id
            let firstCategoryId = this.category.topCategoryId === '' ? '' : this.category.topCategoryId.id
            let secondCategoryId = this.category.subCategoryId === '' ? '' : this.category.subCategoryId.id
            let threeCategoryId = this.category.categoryId === '' ? '' : this.category.categoryId.id
            let categoryId = ''
            for (let k in this.category) {
              if (this.category[k].categoryName === 'VIP' || this.category[k].bottom || this.category[k].level === 3) {
                categoryId = this.category[k].id
              }
            }
            if (this.category.ownCategoryId.id == 8 || this.category.ownCategoryId.id == 13) {
              categoryId = this.category.ownCategoryId.id
            }
            if (categoryId === '') {
              this.$message.error('未选择最底层类')
              return
            }

            // let categoryId = this.category.categoryId !== '' ? this.category.categoryId
            //   : this.category.subCategoryId !== '' ? this.category.subCategoryId
            //     : this.category.topCategoryId !== '' ? this.category.topCategoryId
            //       : this.category.ownCategoryId !== '' ? this.category.ownCategoryId : ''
            // let topCategoryId = this.category.ownCategoryId
            let dictIdSet = []
            this.attrList.forEach(attr => {
              dictIdSet.push(attr.id)
            })
            let spuTags = []
            this.tagList.forEach(tag => {
              spuTags.push(tag.label)
            })
            spuTags = spuTags.join(' ')
            let { spuVideo, spuName, spuDesc, spuAttachmentUrl, spuProperty, primaryImages, primaryAppImages, phoneDetail, pcDetail, spuType, isSingleSkuGroup, isPdf, startupsSpu } = this.basicInfo
            let spuVO = {
              categoryId,
              firstCategoryId,
              secondCategoryId,
              spuAttachmentUrl,
              threeCategoryId,
              dictIdSet,
              spuTags,
              pcDetail,
              phoneDetail,
              primaryImages,
              primaryAppImages,
              topCategoryId,
              spuProperty,
              spuDesc,
              spuName,
              spuVideo,
              spuType,
              isSingleSkuGroup,
              isPdf,
              startupsSpu
            }
            if (+this.$route.query.id === 0) {
              console.log('spuVO', spuVO)
              spuAdd(spuVO).then(res => {
                if (res.data.success) {
                  // let startupsSpu = res.data.data.startupsSpu
                  let startupsSpu = false
                  if (res.data.data.topCategoryId == 10) {
                    startupsSpu = true
                  } else {
                    startupsSpu = false
                  }
                  this.$router.push({
                    path: './createnewsku',
                    query: {
                      categoryId: this.category.ownCategoryId.id,
                      spuProperty,
                      list: dictIdSet,
                      id: res.data.data.id,
                      spuName: this.basicInfo.spuName,
                      spuType: this.basicInfo.spuType,
                      startupsSpu: startupsSpu,
                      showPoint: this.category.ownCategoryId.id == 13
                    }
                  })
                }
              })
            } else if (+this.$route.query.id === 1) {
              spuSeriesAdd(spuVO).then(res => {
                if (res.data.success) {
                  // let startupsSpu = res.data.data.startupsSpu
                  let startupsSpu = false
                  if (res.data.data.topCategoryId == 10) {
                    startupsSpu = true
                  } else {
                    startupsSpu = false
                  }
                  this.$router.push({
                    path: './createsyssku',
                    query: {
                      categoryId: this.category.ownCategoryId.id,
                      spuProperty,
                      spuId: res.data.data.id,
                      startupsSpu: startupsSpu,
                      showPoint: this.category.ownCategoryId.id == 13
                    }
                  })
                }
              })
            }
          }
        })
      })
    },
    deleteItem (index) {
      this.basicInfo.dictIdSet.splice(index, 1)
    },
    getSelectAttr (val) {
      this.attrList = val
      this.attrList.forEach(item => {
        this.basicInfo.dictIdSet.push(item.id)
      })
    },
    changePage (val) {
      this.paginationQueryInfo = val
      this.getPaginationList()
    },
    whiteChangePage (val) {
      this.whiteQueryInfo = val
      this.getWhitePageList()
    },
    handleSelectionChange (val) {
      this.choiceAttrList = val
    },
    handleTagChange (val) {
      this.choiceTagList = val
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";

@deep: ~">>>";

.address-list {
  margin-left: 0 !important;
  display: flex;

  .address-ipt2 {
    margin-right: 0 !important;
    margin-left: 0 !important;

    @{deep} .el-form-item__content {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  @{deep} .address-ipt {
    .el-form-item__content {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .el-form-item {
    display: inline-block;
  }
}

.el-input-number {
  line-height: 30px !important;

  /deep/ .el-input-number__increase {
    line-height: 15px !important;
  }
}
</style>
